module.exports = __webpack_public_path__ + "static/img/guide_character.ee1c806.png";